module.exports = __webpack_public_path__ + "static/img/SHJC.da893e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/SHJC.png
// module id = zMeQ
// module chunks = 34